export const JUMP_TYPE_NONE = 'none'
export const JUMP_TYPE_CUSTOM = 'custom'
export const JUMP_TYPE_COMPETITION = 'competition'
export const JUMP_TYPE_ACTIVITY_PARTICIPATION = 'activity_participation'
export const JUMP_TYPE_ARTIST = 'artist'
export const JUMP_TYPE_NOTICE = 'notice'
export const JUMP_TYPE_TALENT = 'talent'
export const JUMP_TYPE_MALL = 'mall'

export const JUMP_TYPE_OPTIONS = [
  { label: '不跳转', value: JUMP_TYPE_NONE },
  { label: '赛事', value: JUMP_TYPE_COMPETITION },
  { label: '活动参与', value: JUMP_TYPE_ACTIVITY_PARTICIPATION },
  { label: '艺人', value: JUMP_TYPE_ARTIST },
  { label: '通告', value: JUMP_TYPE_NOTICE },
  { label: '才艺中心', value: JUMP_TYPE_TALENT },
  { label: '商城', value: JUMP_TYPE_MALL },
  { label: '自定义链接', value: JUMP_TYPE_CUSTOM }
]

export const ARTIST_PAGE_PROFILE = 'profile'
export const ARTIST_PAGE_STAR_PROFILE = 'star_profile'

export const ARTIST_PAGE_OPTIONS = [
  { label: '艺人资料', value: ARTIST_PAGE_PROFILE },
  { label: '艺人IP档案', value: ARTIST_PAGE_STAR_PROFILE }
]

export const TALENT_MODE_TAXONOMY = 'by_taxonomy'
export const TALENT_MODE_USER = 'by_user'

export const TALENT_MODE_OPTIONS = [
  { label: '按分类', value: TALENT_MODE_TAXONOMY },
  { label: '按用户', value: TALENT_MODE_USER }
]

function text(value) {
  return value === undefined || value === null ? '' : String(value).trim()
}

export function createEmptyJumpConfig(type = JUMP_TYPE_NONE) {
  return {
    type,
    competitionId: '',
    competitionTitle: '',
    activityParticipationId: '',
    activityParticipationTitle: '',
    artistId: '',
    artistName: '',
    artistPage: ARTIST_PAGE_PROFILE,
    noticeId: '',
    noticeTitle: '',
    talentMode: TALENT_MODE_TAXONOMY,
    taxonomyId: '',
    taxonomyName: '',
    artistUserId: '',
    videoId: '',
    videoTitle: '',
    parentCategoryId: '',
    parentCategoryName: '',
    categoryId: '',
    categoryName: '',
    productId: '',
    productTitle: '',
    productCoverUrl: '',
    customUrl: '',
    label: ''
  }
}

export function normalizeJumpConfig(raw) {
  const source = raw && typeof raw === 'object' ? raw : {}
  const type = text(source.type) || JUMP_TYPE_NONE
  return {
    ...createEmptyJumpConfig(type),
    ...source,
    type
  }
}

export function buildJumpLabel(config) {
  const item = normalizeJumpConfig(config)
  if (item.type === JUMP_TYPE_NONE) return '不跳转'
  if (item.type === JUMP_TYPE_CUSTOM) {
    return item.customUrl ? `自定义 / ${item.customUrl}` : '自定义链接'
  }
  if (item.type === JUMP_TYPE_COMPETITION) {
    return item.competitionTitle ? `赛事 / ${item.competitionTitle}` : '赛事'
  }
  if (item.type === JUMP_TYPE_ACTIVITY_PARTICIPATION) {
    return item.activityParticipationTitle
      ? `活动参与 / ${item.activityParticipationTitle}`
      : '活动参与'
  }
  if (item.type === JUMP_TYPE_ARTIST) {
    const pageLabel = item.artistPage === ARTIST_PAGE_STAR_PROFILE ? 'IP档案' : '资料'
    return item.artistName ? `艺人 / ${pageLabel} / ${item.artistName}` : `艺人 / ${pageLabel}`
  }
  if (item.type === JUMP_TYPE_NOTICE) {
    return item.noticeTitle ? `通告 / ${item.noticeTitle}` : '通告'
  }
  if (item.type === JUMP_TYPE_TALENT) {
    const modeLabel = item.talentMode === TALENT_MODE_USER ? '按用户' : '按分类'
    const scope = item.talentMode === TALENT_MODE_USER
      ? (item.artistName || item.artistUserId)
      : (item.taxonomyName || item.taxonomyId)
    const videoPart = item.videoTitle || item.videoId
    if (scope && videoPart) return `才艺中心 / ${modeLabel} / ${scope} / ${videoPart}`
    if (videoPart) return `才艺中心 / ${modeLabel} / ${videoPart}`
    return `才艺中心 / ${modeLabel}`
  }
  if (item.type === JUMP_TYPE_MALL) {
    const categoryLabel = item.parentCategoryName && item.categoryName
      ? `${item.parentCategoryName} / ${item.categoryName}`
      : (item.categoryName || '')
    if (item.productTitle) return `商城 / ${categoryLabel || '商品'} / ${item.productTitle}`
    if (categoryLabel) return `商城 / ${categoryLabel}`
    return '商城'
  }
  return item.label || ''
}

function appendQuery(path, params) {
  const entries = Object.keys(params || {})
    .filter((key) => text(params[key]))
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(text(params[key]))}`)
  if (!entries.length) return path
  return `${path}?${entries.join('&')}`
}

export function buildJumpUrl(config) {
  const item = normalizeJumpConfig(config)
  if (item.type === JUMP_TYPE_NONE) return ''
  if (item.type === JUMP_TYPE_CUSTOM) return text(item.customUrl)
  if (item.type === JUMP_TYPE_COMPETITION) {
    if (!text(item.competitionId)) return ''
    return appendQuery('/pages/artist/competition/detail', { id: item.competitionId })
  }
  if (item.type === JUMP_TYPE_ACTIVITY_PARTICIPATION) {
    if (!text(item.activityParticipationId)) return ''
    return appendQuery('/pages/artist/activity-participation/detail', { id: item.activityParticipationId })
  }
  if (item.type === JUMP_TYPE_ARTIST) {
    if (!text(item.artistId)) return ''
    return appendQuery('/pages/artist/gallery-profile/index', {
      id: item.artistId,
      section: item.artistPage === ARTIST_PAGE_STAR_PROFILE ? ARTIST_PAGE_STAR_PROFILE : ''
    })
  }
  if (item.type === JUMP_TYPE_NOTICE) {
    if (!text(item.noticeId)) return ''
    return appendQuery('/pages/artist/notice/detail', { id: item.noticeId })
  }
  if (item.type === JUMP_TYPE_TALENT) {
    if (!text(item.videoId)) return ''
    const params = { videoId: item.videoId }
    if (item.talentMode === TALENT_MODE_USER && text(item.artistUserId)) {
      params.artistUserId = item.artistUserId
    } else if (text(item.taxonomyId)) {
      params.taxonomyId = item.taxonomyId
    }
    return appendQuery('/pages/artist/talent-center/index', params)
  }
  if (item.type === JUMP_TYPE_MALL) {
    if (!text(item.productId)) return ''
    return appendQuery('/pages/artist/shop/detail', { id: item.productId })
  }
  return ''
}

export function buildJumpLinkResult(rawConfig) {
  const jumpConfig = normalizeJumpConfig(rawConfig)
  const label = buildJumpLabel(jumpConfig)
  const jumpUrl = buildJumpUrl(jumpConfig)
  return {
    jumpConfig: {
      ...jumpConfig,
      label
    },
    jumpUrl,
    jumpLabel: label
  }
}

export function resolveJumpDisplay(row) {
  if (!row) return '-'
  if (row.jumpLabel) return row.jumpLabel
  if (row.jumpConfig && row.jumpConfig.label) return row.jumpConfig.label
  return row.jumpUrl || '-'
}

export function inferJumpConfigFromValue(value) {
  if (!value) {
    return createEmptyJumpConfig(JUMP_TYPE_NONE)
  }
  if (value.jumpConfig && value.jumpConfig.type) {
    return normalizeJumpConfig(value.jumpConfig)
  }
  const jumpUrl = text(value.jumpUrl)
  if (!jumpUrl) {
    return createEmptyJumpConfig(JUMP_TYPE_NONE)
  }
  return {
    ...createEmptyJumpConfig(JUMP_TYPE_CUSTOM),
    customUrl: jumpUrl
  }
}

export function flattenMallLevel2Categories(tree) {
  const result = []
  const walk = (nodes) => {
    ;(nodes || []).forEach((node) => {
      if (Number(node.level) === 2) {
        result.push(node)
      }
      if (node.children && node.children.length) {
        walk(node.children)
      }
    })
  }
  walk(Array.isArray(tree) ? tree : [])
  return result
}

export function findMallCategoryInTree(tree, categoryId) {
  const targetId = text(categoryId)
  if (!targetId) return null
  for (const parent of Array.isArray(tree) ? tree : []) {
    if (String(parent.id) === targetId) {
      return { node: parent, parent: null }
    }
    for (const child of parent.children || []) {
      if (String(child.id) === targetId) {
        return { node: child, parent }
      }
    }
  }
  return null
}

export function resolveMallCategorySelection(tree, config) {
  const item = normalizeJumpConfig(config)
  if (item.type !== JUMP_TYPE_MALL || !text(item.categoryId)) {
    return item
  }
  if (text(item.parentCategoryId)) {
    return item
  }
  const matched = findMallCategoryInTree(tree, item.categoryId)
  if (!matched || !matched.parent) {
    return item
  }
  return {
    ...item,
    parentCategoryId: String(matched.parent.id),
    parentCategoryName: matched.parent.categoryName || ''
  }
}
